import React from 'react';
import { productPath } from '../../utils';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Row } from 'react-flexbox-grid';
import Card from '@material-ui/core/Card';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';
import VisualizadorImagenes from './visualizadorImagenes/visualizadorImagenes';
import DatosExtra from './datosExtra/datosExtra';
import SelectorCantidad from '../Common/selectorCantidad/selectorCantidad';
import VisualizadorPrecio from './visualizadorPrecio/visualizadorPrecio';
import VisualizadorPrecioSinImpuestos from './visualizadorPrecioSinImpuesto/visualizadorPrecioSinImpuesto';
import ArticuloAlternativa from './articuloAlternativa/articuloAlternativa';
import './style.css';
import 'react-image-gallery/styles/css/image-gallery.css';
import Heading from '../UI/Texts/Heading';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import ImageModal from '../UI/Modals/ImageModal';

const styles = theme => ({});

const NombreArticuloTooltip = withStyles((theme) => ({
  tooltip: {
    background: '#000000 0% 0% no-repeat padding-box',
    boxShadow: '0px 3px 6px #00000029',
    borderRadius: '4px',
    padding: '0px',
    opacity: '1 !important',
    margin: '7px 0 4px 25px !important'
  },
}))(Tooltip);

class ArticuloItem extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      indiceInferior: 0,
      indiceSuperior: 3,
      precioPrincipalCasoDos: 0,
      cantidadPedido: this.props.cantidadInicial,
      showAlternativas: false,
      cantidadInicialAlternativas: 0,
      usuario: props.usuario || {},
      modalAbierto: false,
      imagenModal: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.cantidadInicial !== nextProps.cantidadInicial) {
      this.setState({ cantidadPedido: nextProps.cantidadInicial });
    }
  }

  onAgregarQuitarCantidad = (cantidad, alternativa) => {
    this.setState({ cantidadPedido: cantidad, showAlternativas: false }, () => {
      setTimeout(() => {
        if (this.state.cantidadPedido === cantidad) {
          this.props.agregarQuitarUnidad(cantidad, this.props.item, alternativa);
        }
      }, 1000);
    });
  };

  onChangeCantidad = (cantidad) => {
    let detallePedidoArticulo;
    let alternativa;
    if (this.props.pedido) {
      detallePedidoArticulo = this.props.pedido.listaPedidoDetalle.find((x) => x.idArticulo === this.props.item.idArticulo);
      if (detallePedidoArticulo) {
        alternativa = detallePedidoArticulo.alternativa;
      }
    }

    const articuloTieneAlternativas = this.props.item.articuloAlternativas && this.props.item.articuloAlternativas.length > 0;
    const mostrarAlternativas = articuloTieneAlternativas && !detallePedidoArticulo;

    if (mostrarAlternativas) {
      this.setState({ showAlternativas: true, cantidadInicialAlternativas: cantidad });
    } else {
      this.onAgregarQuitarCantidad(cantidad, alternativa);
    }
  };

  openModal = (image) => {
    this.setState({ modalAbierto: true, imagenModal: image });
  };

  closeModal = () => {
    this.setState({ modalAbierto: false, imagenModal: null });
  };

  render() {
    const { item, configVidriera, mostrarPrecioEnRelacionados } = this.props;
    const { modalAbierto, imagenModal } = this.state;
    let { usuario } = this.props;
    usuario = usuario || {};
    const porcentajeDescuentoBackend = Number(item.porcentajeDescuento);
    const porcentajeDescuento = Number.isFinite(porcentajeDescuentoBackend) && porcentajeDescuentoBackend !== 0
      ? Math.abs(porcentajeDescuentoBackend)
      : null;

    const showPrice = () => {
      if (mostrarPrecioEnRelacionados) {
        return (
          <div>
            <VisualizadorPrecio
              precioLista={item.precioLista}
              precioPromocional={item.precioPromocional}
              porcentajeDescuentoFullCatalogo={usuario ? usuario.porcentajeDescuentoFullCatalogo : null}
            />
            <VisualizadorPrecioSinImpuestos
              precioSinImpuestos={item.precioSinImpuestos}
            />
          </div>
        );
      }

      const renderVisualizadorPrecio = () => {
        if (configVidriera === "2" || configVidriera === 2) {
          return item.catalogoEntradaActivo && (
            <VisualizadorPrecio
              precioLista={item.precioLista}
              precioPromocional={item.precioPromocional}
              porcentajeDescuentoFullCatalogo={usuario ? usuario.porcentajeDescuentoFullCatalogo : null}
            />
          );
        } else if (configVidriera === "1" || configVidriera === 1) {
          if (!usuario.id) {
            return null;
          } else {
            return item.catalogoEntradaActivo && (
              <VisualizadorPrecio
                precioLista={item.precioLista}
                porcentajeDescuentoFullCatalogo={usuario.porcentajeDescuentoFullCatalogo}
              />
            );
          }
        } else {
          return item.catalogoEntradaActivo && usuario && (
            <VisualizadorPrecio
              precioLista={item.precioLista}
              porcentajeDescuentoFullCatalogo={usuario.porcentajeDescuentoFullCatalogo}
            />
          );
        }
      };

      return (
        <div>
          {renderVisualizadorPrecio()}
          {item.catalogoEntradaActivo && (
            <VisualizadorPrecioSinImpuestos
              precioSinImpuestos={item.precioSinImpuestos}
            />
          )}
        </div>
      );
    };

    return (
      <div className='articulos'>
        <Card className={`card ${!usuario.id ? "cardNoLogin" : ""}`} style={{ position: "relative" }}>
          <div className='cardImgContainer'>
            {this.props.instalacion.permitirNavegacionDetalleProducto ? (
              <Link to={productPath(item.idArticulo, item.nombre)}>
                <VisualizadorImagenes
                  item={item}
                  onImageClick={this.openModal}
                />
              </Link>
            ) : (
              <VisualizadorImagenes
                item={item}
                onImageClick={this.openModal}
              />
            )}
            {porcentajeDescuento > 0 && this.props.item.catalogoEntradaActivo && (
              <div className='labelDescuento'>
                {porcentajeDescuento.toFixed(0)}%
              </div>
            )}
            {this.props.srcImgOferta &&
              <div className='selloOferta'>
                <img alt="" src={this.props.srcImgOferta} />
              </div>}
          </div>
          <div className='ContainerCardContent'>
            <div className='nameContainer'>
              {
                <NombreArticuloTooltip
                  TransitionComponent={Zoom}
                  placement="bottom-start"
                  style={{ opacity: '1' }}
                  enterTouchDelay={10}
                  title={
                    <div className='containerTooltipNombreAritulo'>
                      {this.props.item.nombre}
                    </div>
                  }
                >
                  <div>
                    {this.props.instalacion.permitirNavegacionDetalleProducto ? (
                      <Link to={productPath(item.idArticulo, item.nombre)} style={{ textDecoration: 'none', color: 'inherit' }}>
                        <Heading tag='h6' weight='bold' className='line-clamp'>{this.props.item.nombre}</Heading>
                      </Link>
                    ) : (
                      <Heading tag='h6' weight='bold' className='line-clamp'>{this.props.item.nombre}</Heading>
                    )}
                  </div>
                </NombreArticuloTooltip>
              }
            </div>
            <div className='spaceBetween'>
              <div className='datoExtraYPrecio'>
                {this.props.item.datosExtra ? (
                  <DatosExtra {...this.props.item} />
                ) : (
                  <div style={{ visibility: 'hidden' }}>
                    &nbsp;
                  </div>
                )}
                {showPrice()}
              </div>
              {configVidriera === "1" && !usuario.id && (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <Button
                    className="infoPrice"
                    variant="outlined"
                    color="primary"
                    onClick={() => { window.location.hash = "/Login"; }}
                  >
                    VER PRECIO
                  </Button>
                </div>
              )}
            {!(configVidriera === "1" && !usuario.id) && !this.props.hideQuantitySelector && (
              <Row className={`rowButton ${this.props.item.catalogoEntradaActivo === false ? 'rowButtonFav' : ''}`}>
                {this.props.item.catalogoEntradaActivo ? (
                  <SelectorCantidad
                    value={this.state.cantidadPedido}
                    onChange={this.onChangeCantidad}
                    incremento={this.props.item.incremento}
                    productoPesable={this.props.item.productoPesable}
                    cantidadLimMin={this.props.item.cantidadLimMin}
                    cantidadLimMax={this.props.item.cantidadLimMax}
                    stockDisponible={true}
                  />
                ) : (
                  <div className="noStock">SIN STOCK</div>
                )}
              </Row>
            )}
            </div>
          </div>
        </Card>
        {this.state.showAlternativas &&
          <ArticuloAlternativa
            open={this.state.showAlternativas}
            item={{ ...this.props.item, srcImgOferta: this.props.srcImgOferta }}
            initialValue={this.state.cantidadInicialAlternativas}
            onClose={() => this.setState({ showAlternativas: false })}
            onConfirm={this.onAgregarQuitarCantidad}
          />}

        {/* Modal para mostrar la imagen del producto ampliada */}
        <ImageModal
          open={this.state.modalAbierto}
          onClose={this.closeModal}
          imgSrc={this.state.imagenModal}
        />
      </div>
    );
  }
}

ArticuloItem.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
  instalacion: PropTypes.object.isRequired,
  precioListaPedido: PropTypes.object.isRequired,
  getBandaDePreciosCasoDos: PropTypes.func.isRequired,
  last: PropTypes.bool,
  pedido: PropTypes.object,
  imagenes: PropTypes.object.isRequired,
  handleOnButtonPedilo: PropTypes.func.isRequired,
  handleOnBorrar: PropTypes.func.isRequired,
  agregarQuitarUnidad: PropTypes.func.isRequired,
  srcImgOferta: PropTypes.string,
  usuario: PropTypes.object,
  configVidriera: PropTypes.any.isRequired,
  onImageClick: PropTypes.func,
  hideQuantitySelector: PropTypes.bool,
  mostrarPrecioEnRelacionados: PropTypes.bool,
};

export default withStyles(styles)(ArticuloItem);
